var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "skel", attrs: { id: "root", "data-theme": _vm.theme } },
    [
      _vm.isMobile
        ? _c("cms-partial-data-provider", {
            attrs: { name: "menu" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return _c(
                    "lateral-menu",
                    _vm._b({}, "lateral-menu", props, false)
                  )
                }
              }
            ])
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "skel--header" },
        [
          _c("cms-partial-data-provider", {
            attrs: { name: "menu" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return _c(
                    "main-header",
                    _vm._b({}, "main-header", props, false)
                  )
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "main",
        { staticClass: "skel--main" },
        [
          _c(
            "transition",
            _vm._b(
              {
                on: {
                  "after-leave": _vm.afterRouteLeave,
                  "after-enter": _vm.afterRouteEnter
                }
              },
              "transition",
              _vm.routeTransitionAttrs,
              false
            ),
            [_c("router-view")],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "skel--footer" },
        [
          _c("cms-partial-data-provider", {
            attrs: { name: "footer" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return _c(
                    "main-footer",
                    _vm._b({}, "main-footer", props, false)
                  )
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-72f19924", { render: render, staticRenderFns: staticRenderFns })
  }
}